import axios from "axios";
const url = process.env.REACT_APP_API_URI;



  export const fetchPdf = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Testpdf`, 
    {
        responseType: 'blob',
    });
  };